import { Skeleton } from "antd";

export default function CourseItemListLoading() {
  return (
    <article className="rounded-lg border border-theme-zinc-200">
      <header className="px-4 py-2.5 rounded-t-lg border-b border-theme-zinc-200">
        <Skeleton.Input active className="!h-7 !w-64" />
      </header>
      <div className="p-4 space-y-3">
        <Skeleton
          active
          paragraph={{ rows: 4, width: ["100%", "95%", "98%", "90%"] }}
          title={false}
        />
      </div>
    </article>
  );
}
